import React from 'react';
import { authRoles } from 'app/auth';

const CategoriesConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.superAdmin,
	routes: [
		{
			path: '/categories',
			component: React.lazy(() => import('./Categories'))
		}
	]
};

export default CategoriesConfig;
